import { favoriteListQueryKeys as e } from "./favoriteListQueryKeys.mjs";
import { propertyQueryKeys as t } from "../properties/usePropertiesQueryKeys.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { favoriteListsApi as i } from "@maat/api-main";
//#region src/favoriteLists/useRemoveListingFromFavoriteMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: ({ listId: e, listingId: t }) => i.removeListing(e, t),
		onSuccess: (n, { listId: r }) => {
			a.invalidateQueries({ queryKey: e.list() }), a.invalidateQueries({ queryKey: e.feed() }), a.invalidateQueries({ queryKey: e.detail(r) }), a.invalidateQueries({ queryKey: t.guestHomePersonal() });
		}
	});
};
//#endregion
export { a as useRemoveListingFromFavoriteMutation };
